/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
import '../../common/time';
import './rewards/reward_config';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "CreditCardPullInquiryType": {
                "values": {
                  "CC_PIT_DO_NOT_USE": 0,
                  "SOFT_PULL": 1,
                  "HARD_PULL": 2,
                  "NO_PULL": 3
                }
              },
              "Offer": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "creditLimitAmount": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "aprBps": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "eligibleToApply": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "projectedFirstDueDate": {
                    "type": ".squareup.common.time.YearMonthDay",
                    "id": 5,
                    "rule": "optional"
                  },
                  "holdRateBps": {
                    "type": "int32",
                    "id": 6,
                    "rule": "optional"
                  },
                  "customerToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "minPayBps": {
                    "type": "int32",
                    "id": 8,
                    "rule": "optional"
                  },
                  "merchantId": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "rewardConfig": {
                    "type": ".squareup.corporate_card.resources.rewards.RewardConfig",
                    "id": 10,
                    "rule": "optional"
                  },
                  "cohortDescription": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "isExpired": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional"
                  },
                  "creditPullInquiryType": {
                    "type": ".squareup.corporate_card.resources.CreditCardPullInquiryType",
                    "id": 13,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditCardPullInquiryType && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.Offer) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreditCardPullInquiryType @ squareup/corporate_card/resources/offer.proto at 9:1
 */
export const CreditCardPullInquiryType = $root.lookupEnum('squareup.corporate_card.resources.CreditCardPullInquiryType').values;
/**
 * --
 * @desc An offer for a credit line
 * --
 *
 * SOURCE Offer @ squareup/corporate_card/resources/offer.proto at 24:1
 */
export const Offer = $root.lookupType('squareup.corporate_card.resources.Offer');
fixType(Offer);
Builder.createAndAttachToType(Offer);